import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { PermissionForm } from "app/interfaces/permission-form.interface";

const permissionsUrlApi = environment.permissionsUrlApi;
const permissionsByRoleUrlApi = environment.permissionsByRoleUrlApi;

const rolesViewPermissionListUrlApi = environment.rolesViewPermissionListUrlApi;
const rolesGetViewPermissionUrlApi = environment.rolesGetViewPermissionUrlApi;

@Injectable()
export class PermissionService {
  public user: PermissionForm;

  constructor(private http: HttpClient) {}

  getPermissions() {
    return this.http
      .request("GET", `${permissionsUrlApi}`)
      .pipe(map((resp: any) => resp));
  }

  getPermissionByRole(id: number) {
    return this.http
      .request("GET", `${permissionsByRoleUrlApi}/` + id)
      .pipe(map((resp: any) => resp));
  }

  getViewPermissions() {
    return this.http
      .request("GET", `${rolesViewPermissionListUrlApi}`)
      .pipe(map((resp: any) => resp));
  }

  getViewPermissionByRole(id: number) {
    return this.http
      .request("GET", `${rolesGetViewPermissionUrlApi}/` + id)
      .pipe(map((resp: any) => resp));
  }

  getPermissionsByUser(menuItems, typeUser, id: number) {
    let permissionRoutes = [
      {
        component: "collections",
        childrenComponents: [
          "listallcollections-list",
          "listmycollections-list",
          "edit-collection",
          "create-collection",
          "show-collection",
        ],
      },
      {
        component: "videos",
        childrenComponents: [],
      },
      {
        component: "incidents",
        childrenComponents: [],
      },
      {
        component: "devices",
        childrenComponents: [
          "list-mydevices-list",
          "listalldevices-list",
          "create-device",
        ],
      },
    ];

    for (let permissionRoute of permissionRoutes) {
      for (let item of menuItems) {
        if (typeUser == "clientuser") {
          item.disabled = false;
          for (let childremItem of item.children) {
            childremItem.disabled = false;
          }
        } else if (
          permissionRoute.component == item.path &&
          permissionRoute.childrenComponents.length > 0
        ) {
          item.disabled = false;
          for (let permissionChildrenRoute of permissionRoute.childrenComponents) {
            for (let childremItem of item.children) {
              if (permissionChildrenRoute == childremItem.path) {
                childremItem.disabled = false;
              }
            }
          }
        }
      }
    }
    console.log(menuItems);
    return menuItems;
  }

  havePermissionRoute(route) {
    return this.http
      .request("GET", `${permissionsUrlApi}/`)
      .pipe(map((resp: any) => resp));
  }
}
